import { Pagination, fetchUtils } from 'react-admin'; //https://marmelab.com/react-admin/Pagination.html
import simpleRestProvider from 'ra-data-simple-rest';


function HTTPSetter (url, options = {}) {
    if (!options.headers) {
        options.headers = new Headers({ Accept: 'application/json' });
    }
    const token = localStorage.getItem('token');
    options.headers.set('Authorization', `Bearer ${token}`);
    options.headers.set('Access-Control-Allow-Origin', process.env.REACT_APP_HOST_URL);

    return fetchUtils.fetchJson(url, options);
};


let baseProvider = simpleRestProvider(process.env.REACT_APP_HOST_URL+ '/api/v1', HTTPSetter)

const dataProvider = {
    ...baseProvider,
    addManyLicenses: (params) => {
        const url = process.env.REACT_APP_HOST_URL+ '/api/v1/licenses-add-many'
        return HTTPSetter(url, {
            method: 'POST',
            body: JSON.stringify(params)
        }).then(({ json }) => ({ data: json }));
    }
}

export {dataProvider, HTTPSetter}